import { ArrowLeftIcon } from "lucide-react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TableOfContents from "../components/TableOfContents";
import MarkdownRenderer from "../components/MarkdownRenderer";
import arcadeVideoImage from "../assets/arcade/arcade-video.jpg";

const ARCADE_ACCENT = "#2142E7";

const Arcade = () => {
	const [markdownContent, setMarkdownContent] = useState("");
	const navigate = useNavigate();

	useEffect(() => {
		window.scrollTo(0, 0);

		fetch("/content/arcade.md")
			.then((response) => response.text())
			.then((text) => setMarkdownContent(text))
			.catch((error) => {
				console.error("Error loading markdown:", error);
				setMarkdownContent("Content loading failed. Please refresh the page.");
			});
	}, []);

	return (
		<div className="relative grid w-full min-h-screen bg-[#F5F1E5] grid-cols-1 lg:grid-cols-[200px_1fr_200px] grid-rows-[30px_1fr_30px]">
			<div className="fixed inset-x-0 top-0 z-40 lg:hidden bg-[#F5F1E5] h-14">
				<div
					className="absolute bottom-0 left-0 right-0 h-[2px]"
					style={{
						background: `linear-gradient(to bottom, #FFFFFF 0%, #FFFFFF 50%, #BFA99F 50%, #BFA99F 100%)`,
					}}
				/>
				<div className="h-full flex items-center px-4">
					<button
						className="flex items-center font-semibold space-x-2 text-white text-sm px-2 py-1 rounded-full shadow"
						style={{ backgroundColor: ARCADE_ACCENT }}
						onClick={() => navigate("/")}
					>
						<ArrowLeftIcon className="w-3 h-3 transition-transform duration-200" />
						<span>Back</span>
					</button>
				</div>
			</div>

			<div className="relative hidden lg:block col-span-3 row-start-1 h-[30px] pointer-events-none z-20">
				<div
					className="absolute bottom-0 left-0 right-0 h-[2px] z-20"
					style={{
						background: `linear-gradient(to bottom, #FFFFFF 0%, #FFFFFF 50%, #BFA99F 50%, #BFA99F 100%)`,
					}}
				/>
			</div>

			<div className="pointer-events-none absolute inset-0 z-10 hidden lg:block">
				<div
					className="absolute top-0 bottom-0 left-[200px] w-[2px]"
					style={{
						background: `linear-gradient(to right, #BFA99F 0%, #BFA99F 50%, #FFFFFF 50%, #FFFFFF 100%)`,
					}}
				/>
				<div
					className="absolute top-0 bottom-0 right-[200px] w-[2px]"
					style={{
						background: `linear-gradient(to left, #BFA99F 0%, #BFA99F 50%, #FFFFFF 50%, #FFFFFF 100%)`,
					}}
				/>
			</div>

			<div className="relative row-start-2 col-start-1 hidden lg:flex flex-col p-2">
				<div className="fixed hidden lg:flex items-start justify-start z-20">
					<TableOfContents
						content={[markdownContent]}
						pageName="Arcade"
						accentColor={ARCADE_ACCENT}
						homeOnly={false}
						darkMode={false}
						inline
					/>
				</div>
			</div>

			<div className="relative hidden lg:block row-start-2 col-start-3"></div>

			<div className="row-start-2 col-start-1 lg:col-start-2 flex flex-col w-full min-w-0 items-center gap-y-8 px-5 sm:px-8 lg:px-14 pt-16 lg:pt-0 bg-white overflow-x-hidden shadow-[0_0_12px_rgba(0,0,0,0.15)]">
				<div
					className="flex flex-col w-full max-w-[1000px] h-fit justify-center items-center mt-0 lg:mt-[30px] gap-2 text-white p-4 rounded-2xl border-[#B7B3B0] bg-gradient-to-b from-white/20 via-white/50 to-white/80 shadow-[0_0_0_1px_rgba(0,0,0,0.08),0_-2px_1px_0_rgba(0,0,0,0.08)_inset,0_2px_1px_0_rgba(255,255,255,0.5)_inset,0_2px_5px_-1px_rgba(0,0,0,0.05),0_1px_3px_-1px_rgba(0,0,0,0.3)] border border-accent/20"
					style={{ backgroundColor: ARCADE_ACCENT }}
				>
					<div className="flex w-full justify-center items-center">
						<div className="flex w-fit mx-auto px-3 py-1 border border-white/60 text-sm text-white/80 rounded-full">
							AI Product Engineer
						</div>
					</div>
					<p className="text-center text-sm text-white/80">
						Jan 2026 — Present
					</p>
					<h1 className="text-center text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-[-0.04em]">
						Arcade
					</h1>
					<div className="flex flex-col items-center gap-1 text-center text-white/80">
						<p className="text-sm">San Francisco, CA</p>
					</div>
					<img
						src={arcadeVideoImage}
						alt="Arcade video creation interface"
						className="w-[calc(100%-2rem)] sm:w-[calc(100%-5rem)] max-w-[640px] max-h-[420px] object-cover rounded-2xl my-6"
					/>
				</div>

				<div className="body w-full max-w-[1000px] min-w-0 p-4 rounded-3xl overflow-hidden">
					<MarkdownRenderer
						markdown={markdownContent}
						className="arcade-content w-full max-w-full min-w-0 overflow-hidden"
					/>
				</div>
			</div>

			<div className="relative col-span-1 lg:col-span-3 row-start-3 h-[30px] pointer-events-none z-20">
				<div
					className="absolute top-0 left-0 right-0 h-[2px] z-20"
					style={{
						background: `linear-gradient(to bottom, #FFFFFF 0%, #FFFFFF 50%, #BFA99F 50%, #BFA99F 100%)`,
					}}
				/>
			</div>
		</div>
	);
};

export default Arcade;
